export default function Spacer({ height = "3rem" }) {
    return (
        <>
            <div style={{ height }} className="d-none d-lg-block" />
            <br />
        </>
    )
}
